import type { FC } from 'preact/compat'
import { MultiSelectListOption } from '../ComboboxListOption'

export type MultiSelectListProps = {
  items: {
    label: string
    value: string
    selected: boolean
    searched?: boolean
    filtered?: boolean
  }[]
  searchTerm?: string
  handleSelectOption: (
    option: {
      value: string
      label: string
    },
    checked: boolean
  ) => void
}
export const MultiSelectList: FC<MultiSelectListProps> = ({
  handleSelectOption,
  items,
  searchTerm
}) => {
  return (
    <>
      {searchTerm ? (
        <>
          {items
            .filter((_item) => _item.searched)
            .map((_v) => (
              <MultiSelectListOption
                key={_v.value}
                value={_v.value}
                label={_v.label}
                selected={_v.selected}
                handleSelectOption={handleSelectOption}
              />
            ))}
        </>
      ) : (
        <>
          {items.map((_v) => (
            <MultiSelectListOption
              key={_v.value}
              value={_v.value}
              label={_v.label}
              selected={_v.selected}
              handleSelectOption={handleSelectOption}
            />
          ))}
        </>
      )}
    </>
  )
}
